import { render, staticRenderFns } from "./invitePortalQuestionnaire.vue?vue&type=template&id=684a5c91&scoped=true"
import script from "./invitePortalQuestionnaire.vue?vue&type=script&lang=js"
export * from "./invitePortalQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a5c91",
  null
  
)

export default component.exports